import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { DocumentCategoryDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-document-category-view',
  templateUrl: './document-category-view.component.html',
  styleUrls: ['./document-category-view.component.css'],
})
export class DocumentCategoryViewComponent implements OnInit {
  @Input() documentCategories: DocumentCategoryDto[];
  documentCategoryForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<DocumentCategoryDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.documentCategoryForm = this.fb.group({
      DocumentCategories: this.fb.array([]),
    });
    this.setDocumentCategory();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display documentCategories
  setDocumentCategory() {
    const control = this.documentCategoryForm.controls
      .DocumentCategories as FormArray;
    this.documentCategories.forEach((e) => {
      control.push(
        this.fb.group({
          DocumentCategoryName: e.DocumentCategoryName,
          id: e.id,
        })
      );
    });
  }

  // method to add DocumentCategory
  addDocumentCategory() {
    const control = this.documentCategoryForm.controls
      .DocumentCategories as FormArray;
    control.insert(
      0,
      this.fb.group({
        DocumentCategoryName: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete documentCategory from arrary list
  deleteDocumentCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.documentCategoryForm.controls
          .DocumentCategories as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.documentCategories.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.documentCategories[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'documentCategory';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('documentCategory');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
